<template>
	<!-- 服务费模板 -->
	<div class="main-container page-container">
		<!-- <Tabs :value="activeTab" @on-click="change" :animated="false"> -->
			<!-- <TabPane label="日常培训" name="0"> -->
				<daliyRecord></daliyRecord>
			<!-- </TabPane> -->
			<!-- <TabPane label="入职培训" name="1">
				<firstRecord></firstRecord>
			</TabPane> -->
		<!-- </Tabs> -->
	</div>
</template>

<script>
	import daliyRecord from "./components/daliyRecord";
	import firstRecord from "./components/firstRecord";
	export default {
		components: {
			daliyRecord,
			firstRecord
		},
		props: {},
		data() {
			return {
				loading: false,
				showBack: false,
				activeTab: '0',
			};
		},
		watch: {},
		computed: {},

		created() {
			this.searchAjax();
		},

		methods: {
			change(tab) {
				this.activeTab = tab
				if (tab == '0') {
			  this.$refs.rankPage && this.$refs.rankPage.init()
				}
			},
			// 删除模板
			delTemplate(item) {
				this.$notice.inquiry("确定删除课程？").then(() => {
					this.$http({
						url: "/buz/courseColumn/del",
						type: "get",
						data: {
							id: item.id
						}
					}).then(res => {
						this.$notice.success("删除课程成功");
						this.searchAjax();
					});
				});
			},
			// 打开模板编辑或新增弹窗
			openTemplateEdit(item) {
				this.$refs.editCourse.open(item || {});
			},
			onSelectChange() {},
			// 获取列表参数
			getParams() {
				const params = Object.assign({}, this.search);
				return params;
			},
			searchAjax() {
				this.pageNum = 1;
				this.getList();
			},
			// 获取列表数据
			getList() {
				const params = this.getParams();
				params.pageNo = this.pageNum;
				params.pageSize = this.pageSize;
				this.tableLoading = true;
				this.$http({
						url: "/buz/courseColumn/read/list",
						type: "post",
						data: params
					})
					.then(res => {
						this.tableLoading = false;
						this.tableData = res.data;
						this.total = res.total;
					})
					.catch(e => {
						this.tableLoading = false;
					});
			}
		}
	};
</script>
<style lang="scss" scoped>
	@import "./index.scss";
	.page-container {
		position: relative;
		/deep/ .ivu-tabs-tab {
			padding-top: 0 !important;
			font-size: 14px;
		}
		/deep/.ivu-tabs{
			height: 100vh;
		}
		/deep/ {
			.ivu-tabs-bar {
				border-bottom: 1px solid #ECECEC;
			}
			.ivu-tabs-ink-bar {
				display: none;
			}
			.ivu-tabs-tab {
				padding: 9px 0 10px;
				margin-right: 44px;
				font-size: 14px;
				color: #515C6F;
			}
			.ivu-tabs-tab-active{
				position: relative;
				color: #236DFF;
				&::before {
					content: "";
					position: absolute;
					left: 0;
					bottom: 1px;
					height: 2px;
					width: 100%;
					background-color: #236DFF;
				}
			}      
		}
	}
</style>
